<template>
	<div v-if="!isSuccess">
		<div style="display: flex; justify-content: center;align-items: center;margin-top: 20px;">
		  <img style="width: 272px; height: 188px;" :src="imgUrl" />
		</div>
		<div>
			<h3 style="padding-top: 8px;padding-left: 16px;color: #7c7a7a;">{{ $t("msg.bookInfo") }}</h3>
			<div style="padding-top: 8px;">
				<van-form label-width="65px" @submit="submit">
					<van-cell-group inset>
						<van-field v-model="newForm.name" name="name" :label="$t('msg.name')"
							:placeholder="$t('msg.namePlaceholder')"
							:rules="[{ required: true, message: $t('msg.nameMessage') }]" />
						<van-field v-model="newForm.phone" type="tel" name="phone" :label="$t('msg.phone')"
							:placeholder="$t('msg.phonePlaceholder')"
							:rules="[{ required: true, message: $t('msg.phoneMessage') }]" />
						<van-field v-model="newForm.address" type="textarea" show-word-limit maxlength="50"
							name="address" :label="$t('msg.address')" :placeholder="$t('msg.addressPlaceholder')"
							:rules="[{ required: true, message: $t('msg.addressMessage') }]" />
						<van-field v-model="newForm.timeStr" is-link readonly name="datePicker"
							:label="$t('msg.timeSel')" :placeholder="$t('msg.timeSelPlaceholder')"
							@click="showPicker = true" />
						<van-popup v-model:show="showPicker" position="bottom">
							<van-date-picker :min-date="minDate" :max-date="maxDate" @confirm="onConfirm"
								@cancel="showPicker = false" />
						</van-popup>
					</van-cell-group>
					<div style="margin: 16px;">
						<van-button round block style="background-color:#E18738;" native-type="submit">
							{{ $t("msg.submit") }}
						</van-button>
					</div>
				</van-form>
			</div>
		</div>
	</div>

	<div v-if="isSuccess" style="margin: 0px;padding: 0px;margin-top: 160px; text-align: center;position: relative;">
		<img :src="require('@/assets/img/success.png')" style="width: 124px;height: 124px;" />
		<div class="center" style="margin-top: 18px; width: 284px;">
			<span style="color: #9095A6; font-size: 18px;">{{ $t("msg.submitPrompt") }}</span>
		</div>
	</div>
</template>

<script>
	import '@/common/jquery.selector-px.js'
	import http from '../utils/request.js'
	import api from '../api/index.js'
	import {
		useI18n
	} from "vue-i18n";
	import {
		useStore
	} from "vuex";


	export default {

		data() {
			return {
				isSuccess: false,
				showPicker: false,
				imgUrl: '',
				value: '',
				newForm: {
					name: '',
					phone: '',
					timeStr: '',
					address: '',
					longitude: '',
					latitude: '',
					modelId: ''
				},
				minDate: new Date(),
				maxDate: new Date(new Date().setYear(new Date().getFullYear() + 1)),
			}
		},
		methods: {
			onConfirm({
				selectedValues
			}) {
				this.newForm.timeStr = selectedValues.join('-');
				this.showPicker = false;
			},
			submit() {
				if (this.newForm.timeStr == '') {
					this.$Message.error(this.$t('msg.timeSelMessage'));
					return;
				}
				// 调用提交预约申请
				api.systemServiceApi.testDrive(this.newForm)
					.then((result) => {
						if (result != null) {
							console.log(JSON.stringify(result));
							// 弹出成功提示
							this.$Message.success(this.$t('msg.submitSuccess'))
							this.isSuccess = true;
						}
					});
			}
		},

		mounted() {
			this.imgUrl = this.$route.query.imgUrl;
			this.newForm.modelId = this.$route.query.modelId;
			this.newForm.address = this.$route.query.address;
			this.newForm.longitude = this.$route.query.lon;
			this.newForm.latitude = this.$route.query.lat;
			
			// console.log(JSON.stringify(this.$route, null, 2))
			// var lang = this.$route.query.lang;
			// if(lang != null){
			//     const store = useStore();
			//     const i18n = useI18n();
			//     i18n.locale.value = lang;
			//     store.commit("setLanguage", lang);
			// }

			document.querySelector('body').setAttribute('style', 'background-color:#eff2f5');
			document.title = this.$t('msg.bookATestTitle')
		}
	}
</script>

<style>

	.center {
		text-align: center;
		position: absolute;
		left: 50%;
		transform: translate(-50%);
	}
</style>